export const wordify = (n: number) => {
  const word = [];
  const numbers = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven',
    8: 'eight',
    9: 'nine',
    10: 'ten',
    11: 'eleven',
    12: 'twelve',
    t3: 'thir',
    t5: 'fif',
    t8: 'eigh',
    20: 'twenty',
  };
  // tslint:disable-next-line:no-bitwise
  const hundreds = 0 | ((n % 1000) / 100);
  // tslint:disable-next-line:no-bitwise
  const tens = 0 | ((n % 100) / 10);
  const ones = n % 10;

  if (n === 0) {
    return 'zero';
  }
  if (n > 999) {
    return n.toString();
  }
  if (hundreds) {
    // @ts-expect-error TS7053 - strict migration
    word.push(numbers[hundreds] + ' hundred');
  }

  if (tens === 0) {
    // @ts-expect-error TS7053 - strict migration
    word.push(numbers[ones]);
  } else if (tens === 1) {
    // @ts-expect-error TS7053 - strict migration
    word.push(numbers['1' + ones] || (numbers['t' + ones] || numbers[ones]) + 'teen');
  } else {
    // @ts-expect-error TS7053 - strict migration
    const part = numbers[tens + '0'] || (numbers['t' + tens] || numbers[tens]) + 'ty';
    // @ts-expect-error TS7053 - strict migration
    word.push(numbers[ones] ? part + '-' + numbers[ones] : part);
  }
  return word.join(' ');
};
